import styleVariables from "../../../styles/var-export.module.scss";
import { ResponsiveBar, ResponsiveBarSvgProps } from "@nivo/bar";
import { SapCountDatum } from "./SapJourney";

interface SapCalcCountChartProps extends ResponsiveBarSvgProps<SapCountDatum> {}

const { darkRed } = styleVariables;

export default function SapCalcCountChart({ data }: SapCalcCountChartProps) {
	return (
		<ResponsiveBar
			data={data}
			margin={{ top: 50, right: 70, bottom: 50, left: 70 }}
			colors={[darkRed]}
			axisRight={{
				legend: "No. of updates",
				legendPosition: "middle",
				legendOffset: 60,
				tickValues: 6,
			}}
			indexBy="record_date"
			keys={["sap_calc_count"]}
			padding={0.5}
			axisLeft={null}
			axisBottom={{
				tickSize: 0,
				tickPadding: 5,
				tickRotation: data.length > 10 ? 45 : 0,
				format: (value) => {
					try {
						const date = new Date(value);
						return date.toLocaleDateString();
					} catch {
						return value;
					}
				},
			}}
			enableGridX={false}
			enableLabel={false}
			animate={false}
		/>
	);
}
